import { Google, Visibility, VisibilityOff } from '@mui/icons-material'
import { Box, Button, Divider, Grid, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik"
import * as yup from "yup"
import { login } from '../../store/features/user/userSlice';

const Login = () => {
  const [visible, setVisible] = useState(false)
    const dispatch=useDispatch();
    const navigate=useNavigate();

    const handleVisible = () => {
      setVisible(!visible)
    }

    let loginSchema = yup.object({
        email: yup.string().email("Email Should be valid").required("Email is Required"),
        password: yup.string().required("Password is Required")
    })
    const formik = useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema: loginSchema,
      onSubmit: (values) => {
        dispatch(login(values))
      }
    })

    const handleNavigate = () => {
        navigate("/")
    }
    
  return (
    <div className='bg-blue-950 border-blue-800 w-[350px] sm:w-[500px] mt-[150px] mb-12 mx-auto p-8 border rounded-md shadow-md'>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
            <Grid item xs={12} >
                <TextField
                    id='email'
                    name='email'
                    label='Email'
                    fullWidth
                    autoComplete='given-email'
                    onChange={formik.handleChange("email")}
                    value={formik.values.email}
                    onBlur={formik.handleBlur("email")}
                />
                <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.email && formik.errors.email ? (
                        <div>{formik.errors.email}</div>
                    ) : null}
                </Box>
            </Grid>
            <Grid item xs={12} >
                <TextField
                    type={visible ? 'text' : 'password'}
                    id='password'
                    name='password'
                    label='Password'
                    fullWidth
                    autoComplete='password'
                    onChange={formik.handleChange("password")}
                    value={formik.values.password}
                    onBlur={formik.handleBlur("password")}
                    InputProps={{
                      endAdornment:(
                        <InputAdornment>
                          <IconButton edge='end' onClick={handleVisible}>
                            {visible ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                />
                <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.password && formik.errors.password ? (
                        <div>{formik.errors.password}</div>
                    ) : null}
                </Box>
            </Grid>
            <div className='ml-auto'>
              <button 
                onClick={() => navigate("/password/forgot")}
                className='text-white'
              >
                Forgot Password
              </button>
            </div>
            <Grid item xs={12} >
                <Button
                    onClick={handleNavigate}
                    className='bg-[#9155FD] w-full'
                    type='submit'
                    variant='contained'
                    size='large'
                    sx={{padding: ".8rem 0", bgcolor: "#1e40af", "&:hover": {bgcolor: "#1e3a8a"}}}
                >
                    Login
                </Button>
            </Grid>
        </Grid>
      </form>

      <div className='flex justify-center flex-col items-center'>
        <div className='py-3 flex items-center'>
            <p className='text-white'>If you don't have account ?</p>
            <Button
              onClick={()=>navigate("/register")}
              className='ml-5' size='small'
            >
              Register
            </Button>
        </div>
      </div>

      <div className='text-white'>
        <Divider>OR</Divider>
      </div>
      
      <Grid item xs={12}>
        <Button
          variant='outlined'
          fullWidth
          endIcon={<Google />}
        >
          Google
        </Button>
      </Grid>
    </div>
  )
}

export default Login
